export default "__VITE_ASSET__CJW7E2rA__"